import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Params } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';

export interface Sorting<T> {
  label: string;
  property: keyof T;
  direction: 'asc' | 'desc';
}

@Component({
  selector: 'app-sorter',
  templateUrl: './sorter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SorterComponent<T> implements OnInit {
  @Input() options: Sorting<T>[] = [];
  @Input() queryParams: T;
  @Output() queryParamsChange = new EventEmitter<T>();
  currentSorting: Sorting<T> | null;

  readonly id = `sort-options-dropdown-${uuidv4()}`;

  ngOnInit(): void {
    this.checkExistingSorting();
  }

  setSorting(option: Sorting<T> | null): void {
    this.currentSorting = option;
    this.queryParams = { ...this.queryParams, ...this.mapToParam(option), page: 0 };
    this.queryParamsChange.emit(this.queryParams);
  }

  private checkExistingSorting(): void {
    const existingParam = (this.queryParams as Record<string, unknown>).orderBy;
    if (existingParam) {
      this.currentSorting = this.options.find((o) => [o.property, o.direction].join(':') === existingParam);
    }
  }

  private mapOptionToString(option: Sorting<T>): string | null {
    return option ? `${String(option.property)}:${option.direction}` : null;
  }

  private mapToParam(option: Sorting<T> | null): Params {
    return {
      orderBy: this.mapOptionToString(option),
    };
  }
}
